import React from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';
import asyncComponent from '../../../../util/asyncComponent';

const Dashboard = ({match}) => (
  
  <div className="app-wrapper">
  {console.log("match_utl dashboard", match.url)}
    <Switch>
      <Redirect exact from={`${match.url}/`} to={`${match.url}index`}/>
      <Route path={`${match.url}/index`} component={asyncComponent(() => import('./routes/casesList'))}/>
      {/* <Route path={`${match.url}/casedetail`} component={asyncComponent(() => import('./routes/caseDetails'))}/> */}
      <Route component={asyncComponent(() => import('../../../../app/routes/extraPages/routes/404'))}/>
    </Switch>
  </div>
);

export default Dashboard;